import {
  Container,
  InputCheckbox,
  InputDropdown,
  InputField,
  InputRadio,
  Text,
} from "@jds/core";
import { useEffect, useState } from "react";
import FormErrorLabel from "../UI/FormErrorLabel/FormErrorLabel";

const CustomFields = ({
  type = null,
  customFieldProp = {},
  setCustomFieldsValue = () => {},
  setCustomFieldsVali = () => {},
}) => {
  const [customField, setCustomField] = useState({});
  const [inputValue, setInputValue] = useState(null);
  useEffect(() => {
    setCustomField(customFieldProp);
  }, []);

  useEffect(() => {
    if (type === "text" || type === "dropdown" || type === "radio") {
      setCustomFieldsValue((pre) => {
        const filterArr = pre?.map((input, index) => {
          if (input?.id === customField?.id) {
            return { ...input, value: inputValue || "" };
          }
          return input;
        });
        // console.log("hello1234fil", filterArr);
        return filterArr;
      });
      if (customField?.required && !inputValue) {
        setCustomFieldsVali((pre) => {
          return { ...pre, [customField?.id]: false };
        });
      } else {
        setCustomFieldsVali((pre) => {
          return { ...pre, [customField?.id]: true };
        });
      }
    }
    if (type === "checkbox") {
      setCustomFieldsValue((pre) => {
        const filterArr = pre?.map((input, index) => {
          if (input?.id === customField?.id) {
            return {
              ...input,
              value: Array.isArray(inputValue) ? inputValue : [],
            };
          }
          return input;
        });
        return filterArr;
      });
      if (customField?.required && (inputValue?.length === 0 || !inputValue)) {
        setCustomFieldsVali((pre) => {
          return { ...pre, [customField?.id]: false };
        });
      } else {
        setCustomFieldsVali((pre) => {
          return { ...pre, [customField?.id]: true };
        });
      }
    }
  }, [inputValue]);

  if (type === "text") {
    return (
      <InputField
        value={inputValue}
        label={`${customField?.questionName} ${
          customField?.required ? "*" : ""
        }`}
        onChange={(e) => {
          setInputValue(e?.target?.value?.substring(0, 40));
          if (customField?.required && !e.target.value) {
            setCustomField((pre) => {
              return { ...pre, err: true };
            });
          } else {
            setCustomField((pre) => {
              return { ...pre, err: false };
            });
          }
        }}
        onBlur={(e) => {
          setCustomField((pre) => {
            return {
              ...pre,
              isTouch: true,
              errMsg: `${customField?.questionName} should not be empty`,
            };
          });
          if (customField?.required && !inputValue) {
            setCustomField((pre) => {
              return { ...pre, err: true };
            });
          }
        }}
        state={customField?.err && customField?.isTouch ? "error" : "none"}
        stateConfig={{
          errorText: customField?.errMsg,
        }}
      />
    );
  }

  if (type === "dropdown") {
    return (
      <InputDropdown
        label={`${customField?.questionName} ${
          customField?.required ? "*" : ""
        }`}
        items={customField?.options?.map((val) => {
          return {
            label: val,
            value: val,
          };
        })}
        onOpen={(e) => {
          setCustomField((pre) => {
            return {
              ...pre,
              isOpen: true,
            };
          });
        }}
        onClose={(e) => {
          if (customField?.isOpen) {
            setCustomField((pre) => {
              return {
                ...pre,
                errMsg: "Please select the value.",
                isTouch: true,
                isOpen: false,
              };
            });
          }
        }}
        onSelect={(i, value) => {
          setInputValue(value);
        }}
        state={
          customField?.required && customField?.isTouch && !inputValue
            ? "error"
            : "none"
        }
        stateConfig={{
          errorText: customField?.errMsg,
        }}
      />
    );
  }

  if (type === "radio") {
    return (
      <>
        <Container direction="column" gap={8} fullWidth>
          <Text
            text={`${customField.questionName} ${
              customField.required ? "*" : ""
            }`}
            appearance="body-xs"
            color="primary_grey_80"
          />
          <Container gap={8} fullWidth direction="column">
            {customField.options?.map((val) => (
              <InputRadio
                label={val}
                suffix="ic_profile"
                prefix="ic_profile"
                size="small"
                checked={inputValue === val ? true : false}
                onClick={(e) => {
                  //   setFormValueForCustom((pre) => {
                  //     return { ...pre, [key]: e.target.value };
                  //   });
                  setInputValue(e.target.value);
                }}
                value={val}
              />
            ))}{" "}
          </Container>
        </Container>
      </>
    );
  }

  if (type === "checkbox") {
    return (
      <div style={{ width: "100%" }}>
        <Container direction="column" fullWidth>
          <Text
            text={`${customField?.questionName} ${
              customField?.required ? "*" : ""
            }`}
            appearance="body-xs"
            color="primary_grey_80"
          />
          <Container
            gap={40}
            fullWidth
            style={{
              flexWrap: "wrap",
              marginTop: "10px",
            }}
          >
            <Container fullWidth direction="column" gap={0}>
              <Container fullWidth direction="column" gap={8}>
                {customField?.options?.map((val) => (
                  <InputCheckbox
                    label={
                      <Text
                        text={`${val}`}
                        appearance="body-xs"
                        color="primary_grey_80"
                      />
                    }
                    size="small"
                    value={val}
                    onChange={(e) => {
                      setCustomField((pre) => {
                        return {
                          ...pre,
                          errMsg: "Please select the value.",
                          isTouch: true,
                        };
                      });
                      if (e.target.checked) {
                        setInputValue((pre) => {
                          if (Array.isArray(pre)) {
                            return [...pre, e.target.value];
                          } else {
                            return [e.target.value];
                          }
                        });
                      } else {
                        setInputValue((pre) => {
                          if (Array.isArray(pre)) {
                            const filterData = pre.filter((item) => {
                              if (item !== e.target.value) {
                                return item;
                              }
                            });
                            return [...filterData];
                          }
                        });
                      }
                    }}
                  />
                ))}
              </Container>
              {customField?.required &&
                customField?.isTouch &&
                (inputValue?.length === 0 || !inputValue) && (
                  <FormErrorLabel errorMsg={customField?.errMsg} />
                )}
            </Container>
          </Container>
        </Container>
      </div>
    );
  }
  return <></>;
};

export default CustomFields;
